<template>
  <div
    @dragenter.prevent="isDrag = true"
    @dragleave.prevent="isDrag = false"
    @dragover.prevent="isDrag = true"
    @drop.prevent="fileDropped"
    class="remaining-space fill-width d-flex flex-column"
  >
    <v-tab-item
      value="uploading"
      class="fill-width remaining-space d-flex upload-data"
      :class="[screenType !== 'desktop' && 'upload-data-mobile']"
    >
      <!--LEFT SIDE-->
      <div
        class="my-2 d-flex flex-column upload-left-side-wrapper"
        :class="screenType !== 'desktop' ? 'remaining-space' : 'upload-data-desktop'"
      >
        <!--UPLOADING DETAILS-->
        <UploadingDetails
          :session="session"
          :userActiveSourceRoutes="userActiveSourceRoutes"
          :filteringErrMessage="filteringErrMessage"
          :startFilteringClicked="startFilteringClicked"
          :restartSessionClicked="restartSessionClicked"
          :lightSessionRestart="lightSessionRestart"
          :activeTab="activeTab"
          :screenType="screenType"
          :filteringProgress="filteringProgress"
          :timer="timer"
          :statusResults="statusResults"
          :verifiedEmails="verifiedEmails"
          :pushToVerifiedEmailsList="email => (verifiedEmails.push(email))"
        />
        <!--PROGRESS-->

        <UploadProgress
          class="overflow-auto"
          v-if="isShowProgressBar && screenType === 'desktop'"
          :filteringProgress="filteringProgress"
          :timer="timer"
          :session="session"
          :screenType="screenType"
        />
      </div>

      <!--RIGHT SIDE-->
      <div
        class="upload-right-side-wrapper d-flex align-center justify-center ma-2"
        v-if="screenType === 'desktop'"
      >
        <!--DROP FILES-->
        <DropFiles
          v-if="levelOfUploading === 'drop' && screenType === 'desktop' && $vuetify.breakpoint.width >= 760"
          :session="session"
          :isDrag="isDrag"
          type="desktop"
        />

        <!--TABLE AND FILES-->
        <div
          v-if="levelOfUploading === 'table' && screenType === 'desktop'"
          class="d-flex flex-column fill-height fill-width"
        >
          <!--TABLE INFO / SESSION INFO-->
          <SessionInfo
            :session="session"
            :curFileUploaded="curFileUploaded"
            :sessionFiles="sessionFiles"
            :sessionSize="sessionSize"
            :cancelSessionClicked="cancelSessionClicked"
          />

          <!--FILES TABLE-->
          <UploadFilesTable
            :session="session"
            :curFileUploaded="curFileUploaded"
            :isDrag="isDrag"
          />
        </div>

        <!--ENDING REPORT-->
        <UploadReportDialog
          v-if="levelOfUploading === 'report' && screenType === 'desktop'"
          :restartSessionClicked="restartSessionClicked"
          :statusResults="statusResults"
          :screenType="screenType"
        />
      </div>
    </v-tab-item>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { api } from '@/config'

//Childrens
import UploadingDetails from './Children/UploadingDetails/UploadingDetails.vue'
import SessionInfo from './Children/SessionInfo/SessionInfo.vue'

//Base components
import Report from '@/components/WebsiteInterface/CommonComponents/Report/Report.vue'
import DropFiles from '@/components/WebsiteInterface/CommonComponents/DropFiles/DropFiles.vue'
import UploadFilesTable from '@/components/WebsiteInterface/CommonComponents/UploadFilesTable/UploadFilesTable.vue'
import UploadProgress from '@/components/WebsiteInterface/CommonComponents/UploadProgress/UploadProgress.vue'
import StepForMobile from '@/components/WebsiteInterface/CommonComponents/StepForMobile.vue'

//Website interface data
import {
  checkUploadingDetails,
  startObjForUpload,
} from '@/components/WebsiteInterface/Websiteinterface'

//Uploading functions
import {
  cancelUploading,
  deleteIndividualFiles,
  startFiltering,
  addDroppedFileOrDirectory,
} from '@/components/WebsiteInterface/uploadingFunctions'
import UploadReportDialog from '@/components/WebsiteInterface/CommonComponents/UploadReportDialog/UploadReportDialog.vue'

export default {
  name: 'UploadDesktop',
  data() {
    return {
      // step: 1,
      ...JSON.parse(JSON.stringify(startObjForUpload)),
    }
  },
  components: {
    UploadingDetails,
    DropFiles,
    UploadFilesTable,
    UploadProgress,
    Report,
    SessionInfo,
    UploadReportDialog,
    StepForMobile,
  },
  props: {
    userActiveSourceRoutes: Array,
    screenType: String,
  },
  watch: {
    session: {
      handler: function (n) {
        checkUploadingDetails(this, 'desktop')
      },
      deep: true,
      immediate: true,
    },
    verifiedEmails: {
      handler() {
        checkUploadingDetails(this, 'desktop')
      },
      deep: true,
    },
    // 'session.interfaceDynamicFields': {
    //   handler: function (n) {},
    // },
    language() {
      checkUploadingDetails(this, 'desktop')
    },

    // 'activeTab.tab': {
    //   handler: function (n) {
    //     checkUploadingDetails(this, 'desktop')
    //     if (n === 'casual') {
    //       this.session.interfaceDynamicFields = JSON.parse(
    //         JSON.stringify(this.loggedUser.interfaceDynamicFieldsForRegistered)
    //       )
    //     }
    //     this.session.selectedCasualUsers = []
    //     this.session.selectedUsers = []
    //     if (this.userActiveSourceRoutes.length > 1)
    //       this.session.selectedRoute = ''
    //   },
    //   immediate: true,
    // },
  },
  computed: {
    ...mapGetters([
      'isInMiddleOfFiltering',
      'loggedUser',
      'language',
      'uploadStep',
      // 'interactiveInterfaceFields',
    ]),
    levelOfUploading() {
      //if not filtering AND there are no files AND there is no report then show drop files
      if (
        !this.isInMiddleOfFiltering &&
        !this.session.filesData.length &&
        !this.statusResults.session.operationId
      )
        return 'drop'

      //if there are files and in middle of filtering
      if (this.session.filesData.length) return 'table'

      //if there is session report
      if (this.statusResults.session.operationId) return 'report'
    },
    isShowDropFiles() {
      if (this.session.filesData.length) return false
      else if (this.isInMiddleOfFiltering) return false
      // else if()
      return true
    },
    isShowProgressBar() {
      if (this.isInMiddleOfFiltering) return true
      return false
    },
  },
  methods: {
    ...mapActions(['GET_LOGGED_USER_ROUTES']),
    ...mapMutations(['SET_UPLOAD_STEP']),
    fileDropped(e) {
      if (this.isInMiddleOfFiltering) return
      addDroppedFileOrDirectory(this, e)
    },

    async startFilteringClicked() {
      if (this.screenType === 'mobile' && this.uploadStep < 3) {
        this.SET_UPLOAD_STEP(3)
      }
      let biggestFileSize = 0
      this.session.filesData.forEach(el =>
        el.file.numbSize > biggestFileSize
          ? (biggestFileSize = el.file.numbSize)
          : null
      )
      try {
        const isSessionApprovedRes = await api.get(
          `filter/sizepermissions?total=${this.session.totalSize}&biggest=${biggestFileSize}`
        )
        console.log(isSessionApprovedRes)
        if (isSessionApprovedRes.status !== 200) return

        startFiltering(this, 'desktop')
      } catch (error) {
        console.log(error)
        return
      }
      // const isSessionApprovedRes = await api.get(
      //   `filter/sizepermissions?total=${this.session.totalSize}&biggest=${biggestFileSize}`
      // )
      // console.log(isSessionApprovedRes)
      // if (isSessionApprovedRes.status !== 200) return

      // startFiltering(this, 'desktop')
    },

    async restartSessionClicked() {
      //if the user is individual and the session wansnt restarted
      if (
        this.loggedUser.role === 'Individual' &&
        !this.session.filesData.length
      )
        await deleteIndividualFiles(
          this.session.operationId,
          this.loggedUser.token
        )

      //this will restart the session
      Object.keys(startObjForUpload).forEach(key => {
        this[key] = JSON.parse(JSON.stringify(startObjForUpload))[key]
      })
      this.SET_UPLOAD_STEP(1)
    },

    lightSessionRestart() {
      //this will run when a user did a session and
      //then changed the route, casuals, subject etc...
      if (!this.session.operationId) return

      this.session.htmlReport = {
        summary: '',
        date: '',
      }
      this.session.operationId = ''

      this.statusResults = {
        intact: 0,
        modified: 0,
        rejected: 0,
        total: 0,
        session: {},
        partial: 0,
      }
    },

    cancelSessionClicked() {
      cancelUploading(this)
    },
    //   testClicked() {
    // console.log(this.session)
    // if (!this.session.test) this.session.test = true
    // else this.session.test = false
    //   },
  },
  
}
</script>

<style scoped src="./UploadDesktop.css"></style>

<style scoped>
/* .uploading-details-mobile-wrapper {
    width: 100% !important;
    margin-bottom: 16px !important;
    height: 100% !important;
  } */
.upload-data-mobile {
  flex-direction: column !important;
  overflow-y: auto !important;
  max-height: 87vh;
  /* padding: 8px !important; */
}

.upload-data-desktop {
      min-height: 280px;
    height: fit-content;
}
</style>
